<template>
  <div class="combobox-rental-dispense-item-display">
    <div class="flow-row flex items-center">
      <ComboboxRentalDispenseItemInfo :rental-dispense-item="item" class="grow" />
      <PBadgeRentalFlowDirection v-if="showBadge" :flow-direction="flowDirection" />
    </div>
  </div>
</template>

<script setup lang="ts">
import PBadgeRentalFlowDirection from "@/components/administration/PBadgeRentalFlowDirection.vue"
import { RentalMutationFlowDirections } from "@/enums/rental-mutation-flow-directions"
import { RentalDispenseItem } from "@/models/rental-dispense-item.model"
import ComboboxRentalDispenseItemInfo from "@/components/administration/combobox-display-templates/basic/ComboboxRentalDispenseItemInfo.vue"

withDefaults(
  defineProps<{
    item: RentalDispenseItem
    flowDirection: RentalMutationFlowDirections
    showBadge?: boolean
  }>(),
  {
    showBadge: true
  }
)
</script>

<style scoped></style>
